import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

export const useHashtagGeneration = () => {
  const [generatingHashtags, setGeneratingHashtags] = useState(false);

  const generateHashtags = async (question: string, answer: string): Promise<string[]> => {
    if (!question.trim() || !answer.trim()) {
      toast.error('Både spørsmål og svar må være fylt ut for å generere hashtags');
      return [];
    }

    setGeneratingHashtags(true);

    try {
      console.log('Generating hashtags for question and answer');
      
      const { data, error } = await supabase.functions.invoke('gemini-agent', {
        body: {
          task: 'generate_hashtags',
          data: {
            question: question.trim(),
            answer: answer.trim()
          }
        }
      });

      if (error) {
        console.error('Error generating hashtags:', error);
        toast.error('Kunne ikke generere hashtags');
        return [];
      }

      if (!data || !data.hashtags || !Array.isArray(data.hashtags)) {
        console.error('Invalid hashtag response:', data);
        toast.error('Ugyldig svar fra hashtag-generering');
        return [];
      }

      console.log('Generated hashtags:', data.hashtags);
      toast.success(`Genererte ${data.hashtags.length} hashtags`);
      return data.hashtags;

    } catch (error) {
      console.error('Error in hashtag generation:', error);
      toast.error('En feil oppstod under generering av hashtags');
      return [];
    } finally {
      setGeneratingHashtags(false);
    }
  };

  return {
    generateHashtags,
    generatingHashtags
  };
};